import React from 'react';
import PropTypes from 'prop-types';
import PhotobookModal from './photobook-modal';
import productType from './types/product-type';
import preSelectionsType from './types/pre-selections-type';
import modalContentType from './types/modal-content-type';
import deliveryOptionType from './types/delivery-option-type';
import NewProduct from '../_utils/new-product';

const PreviewableProducts = ({
  products,
  modalOpen,
  modalContent,
  preSelections,
  favourites,
  roundOption,
  handleProductOnClick,
  handleModalContent,
  handleModalClose,
  deliveryOptions,
  showThumbnailImages,
  productsWithMultipleVariants,
  selectedDeliveryOptions,
  loggedIn
}) => {
  const getSizeAndCover = productTitle => {
    const [size, coverFirstWord, coverSecondWord] = productTitle.split(' ');
    return { size, coverFirstWord, coverSecondWord };
  };

  const showPreviewImages = product => {
    const { coverFirstWord, coverSecondWord } = getSizeAndCover(product.title);
    const isPremium =
      /premium/i.test(coverFirstWord) || /premium/i.test(coverSecondWord);
    const hasPreviewImages =
      product.preview_images && product.preview_images.length;

    return !isPremium && hasPreviewImages;
  };

  return (
    <>
      <div className="row row-cols-2 row-cols-md-4 row-cols-lg-5 px-2">
        {products.map(product => {
          return showPreviewImages(product) ? (
            <NewProduct
              key={product.id + product.theme_name}
              {...product}
              preSelections={preSelections}
              favourites={favourites}
              roundOption={roundOption}
              showThumbnailImages={showThumbnailImages}
              handleOnClick={handleProductOnClick}
              handleModalContent={handleModalContent}
              productsWithMultipleVariants={productsWithMultipleVariants}
              selectedDeliveryOptions={selectedDeliveryOptions}
              loggedIn={loggedIn}
            />
          ) : (
            <NewProduct
              key={product.id + product.theme_name}
              {...product}
              preSelections={preSelections}
              favourites={favourites}
              roundOption={roundOption}
              showThumbnailImages={showThumbnailImages}
              productsWithMultipleVariants={productsWithMultipleVariants}
              selectedDeliveryOptions={selectedDeliveryOptions}
              loggedIn={loggedIn}
            />
          );
        })}
      </div>
      <PhotobookModal
        open={modalOpen}
        handleModalClose={handleModalClose}
        modalContent={modalContent}
        deliveryOptions={deliveryOptions}
      />
    </>
  );
};

PreviewableProducts.propTypes = {
  favourites: PropTypes.arrayOf(PropTypes.string),
  modalOpen: PropTypes.bool.isRequired,
  modalContent: modalContentType.isRequired,
  preSelections: preSelectionsType.isRequired,
  products: PropTypes.arrayOf(productType).isRequired,
  roundOption: PropTypes.bool.isRequired,
  handleProductOnClick: PropTypes.func.isRequired,
  handleModalContent: PropTypes.func.isRequired,
  handleModalClose: PropTypes.func.isRequired,
  deliveryOptions: PropTypes.arrayOf(deliveryOptionType).isRequired,
  selectedDeliveryOptions: PropTypes.string
};

PreviewableProducts.defaultProps = {
  favourites: null,
};

export default PreviewableProducts;
